module.exports = __webpack_public_path__ + "img/fire60.6cabf3e7.gif";